<template>

    <dmb-asset
        class="widget-content-video" ref="asset"
        v-if="widget?.settings?.assetId" :style="resolvedStyle"
        :asset-id="widget.settings.assetId"
        :content-mode="widget.settings.contentMode"
        :repeat="widget.settings.repeat" :freeze="freeze"/>

    <div class="widget-content-placeholder" v-else>{{ $t('app.widgets.widgetContentVideo.noVideo') }}</div>

</template>

<script>

import { Options, Vue } from 'vue-class-component';

import Asset from '../ui/Asset.vue';

export default Options({
    name: 'dmb-widget-content-video',
    props: {
        widget: Object,
        freeze: Boolean,
        visible: Boolean
    },
    components: {
        [Asset.name]: Asset
    }
})(
    class WidgetContentVideo extends Vue {

        created(){

            this.$watch('visible', this.playIfNeeded);
        }

        playIfNeeded(){

            if(this.freeze){
                return;
            }

            if(this.visible){
                this.$refs.asset?.playVideo();
            }
        }

        get resolvedStyle(){

            return {

                'width': '100%',
                'height': '100%'
            };
        }
    }
);

</script>